'use client';

import { useTranslations } from 'next-intl';
import { ListPageHeader } from '@terra/ui-design-system';

export function AgentExecutionsPageHeader() {
  const tPage = useTranslations('proxy.executions.page');
  const tAgent = useTranslations('agentExecutions.page');

  return (
    <ListPageHeader title={tPage('title')} subtitle={tAgent('subtitle')} />
  );
}
